<template>
	<div id="paymentInfo" class="paymentInfo" >
		<div class="paymentInfo_content container">
			<SectionHeader topText="2023 SEASON TICKET HOLDER" bottomText="Payment Information" />
			<!-- <div class="inner-container">
				<div class="header">
					<h5>first payment for season ticket balance due</h5>
					<h3>wednesday, March 8, 2023</h3>
				</div>
				<div class="content">
					<p>
						Log in to your <a target="_blank" href="https://mpv.tickets.com/?orgid=40490&agency=CBMT_MYTIXX&tfl=Chicago_Cubs-Tickets-My_Cubs_Tickets-button-x0-Phone-Portrait&adobe_mc=MCMID%3D50866825211294216784319722611162388277&MCORGID=A65F776A5245B01B0A490D44%40AdobeOrg&TS=1665586917&_ga=2.133836878.1939872624.1665586917-527691392.1665586917#/auth/login?fullret=%2Fticketmanagement%2F%3Forgid%3D40490%26agency%3DCBMT_MYTIXX%26tfl%3DChicago_Cubs-Tickets-My_Cubs_Tickets-button-x0-Phone-Portrait%26adobe_mc%3DMCMID%253D50866825211294216784319722611162388277%26MCORGID%3DA65F776A5245B01B0A490D44%2540AdobeOrg%26TS%3D1665586917%26_ga%3D2.133836878.1939872624.1665586917-527691392.1665586917">"My Cubs Tickets" </a> select "Renew/Make Payments" in the menu on the left side of your screen.
						Then, select your ticket plan and continue to checkout.
					</p>
				</div>
			</div> -->
			<div class="payInfo">
				<img class="paymentImg" :src="require(`@/assets/images/account/Cubs_220917_23 (2).png`)" alt="">
				<div class="payment_content">
					<div class="header">
						<h3>payment method</h3>
					</div>
					<div class="details">
						<div class="online_payment_info">
							<!-- <img :src="require(`@/assets/images/account/online-payment.svg`)" alt=""> -->
							<div>
								<!-- <p>Submit payment online via "My Cubs Tickets."</p> -->
								<!-- <div class="addtional_info"> -->
									<p>When selecting seats, you will have the option of submitting full payment or a nonrefundable first payment of 50 percent of your season ticket balance. Your initial payment must be made via credit card and any remaining balance is due by 5 p.m. CT Wednesday, March 8, 2023.</p>
									<!-- <p>If you'd like to use more than one credit card for your payment, you must select the "Set Up Payment Plan" option at the checkout screen and uncheck the box that says "Use one payment method for all future installments." Please note you are only able to split payments on a desktop or tablet. The feature to split payment is not available on a mobile device.</p> -->
								<!-- </div> -->
								<p>Please note there is a yearly $20 processing fee added to the total for your season ticket package.</p>
								<!-- <p>We accept Mastercard, Visa, American Express and Discover.</p> -->

							</div>
						</div>
						<!-- <a href="#">Pay Now Via “My Cubs Tickets”</a> -->
					</div>


				</div>
			</div>
		</div>
		<divider img_src="divider-4.png" />
		<!-- <divider img_src="divider-3.png" /> -->
	</div>
</template>
<script>
import SectionHeader from "@/components/SectionHeader";
import divider from "@/components/divider";

export default {
	name: "paymentInfo",
	components: { SectionHeader, divider },

	// setup() {
	// 	const store = useStore();
	//
	// 	// State
	// 	const state = reactive({
	// 		purl: computed(() => store.getters["purl/getAccount"]),
	// 	});
	//
	// 	return { ...toRefs(state) };
	// },
};

</script>
<style lang="scss" scoped>
.paymentInfo {
	// background-image: url("~images/account/bg.jpeg");
	background-color: theme-var($--ch-theme-background-secondary);
	background-image: url("~images/bgImage.jpg");
	background-size: cover;


	@include media-breakpoint-down(sm) {
		background-image: url("~images/bgImage_mobile.jpg");
		// background-size:cover;
	}
	&_content {
		align-items: center;
		z-index: 1;
		height: 100%;
		padding: 150px 100px 100px 120px;
		@include media-breakpoint-down(sm) {
			padding: 150px 30px 100px 30px;
		}
		@include media-breakpoint-only(md) {
			padding: 150px 30px 100px 30px;
		}
		@media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
			padding: 150px 50px 100px 50px;
		}
		.inner-container{
			margin: 50px auto;
			padding: 0px 130px;
			@include media-breakpoint-down(sm) {
				padding: 0px 10px;
			}
			@include media-breakpoint-only(md) {
				padding: 0px 10px;
			}
			@media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
				padding: 0px 10px;
			}
			.header{

				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				padding: 15px 10px;
				gap: 10px;
				background: #CC3433;
				color:white;
				text-transform: uppercase;
				font-family: 'Verlag Condensed Book';
				font-style: normal;
				font-weight: 400;
				text-align:center;
				line-height: 100%;
				h5{
					margin-bottom:0px;
					font-size: 20px;
					@include media-breakpoint-down(sm) {
						font-size: 14px;
					}
				}
				h3{
					margin-bottom:0px;
					font-size: 30px;
					@include media-breakpoint-down(sm) {
						font-size: 24px;
					}
				}
			}
			.content{
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				margin: 0 10px;
				padding: 15px 10px;
				gap: 30px;
				background: #FFFFFF;
				box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
				@include media-breakpoint-down(sm) {

			   }
				p{
					margin-bottom:0px;
					text-align:center;
					color: #0B2255;
					font-family: 'Verlag Book';
					font-weight: 325;
					font-size: 16px;
					line-height: 145%;
				}
				a{
					color: #0B2255 !important;
					text-decoration:none;
				}

		   }
		}
		.payInfo{
			display: flex;
			margin-top:50px;
			// justify-content: space-between;
			// align-items: center;
			@include media-breakpoint-down(sm) {
				flex-direction: column;
		   }
		   @include media-breakpoint-only(md) {
			   flex-direction: column;

		   }
		   @media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
			   flex-direction: column;
		   }
		   .paymentImg{
			  width: 500px;
			  @include media-breakpoint-only(md) {
				  width: 100%;
			  }
			  @include media-breakpoint-down(sm) {
	  				width: 100%;
	  		   }
			   @media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
				   width: 100%;
			   }
			 //height:auto;
			  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.6);
				  @media only screen and (min-width: 578px) and (max-width: 1199px) {
					 // margin-bottom:40px;
				 }

			  }
		   .payment_content{
			   margin-left:30px;
			   background:white;
			   box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.6);
			   // margin: 0 -10px;
			   @include media-breakpoint-down(sm) {
	   			 margin-left:0px;
				 // padding: 10px;
				 margin-top:30px;
	   		   }
			   @include media-breakpoint-only(md) {
				   margin-left:0px;
  				 // padding: 10px;
				  margin-top:30px;
			   }
			   @media only screen and (min-width: 1023px) and (max-width: 1025px) and (-webkit-min-device-pixel-ratio: 1.5) {
				   margin-left:0px;
				   // padding: 10px;
				    margin-top:30px;
	   			}
			   .header{
				   background: #0E3386;
				   color:white;
				   text-transform: uppercase;
				   font-family: 'Verlag Condensed Book';
				   font-style: normal;
				   font-weight: 400;
				   text-align:center;
				   line-height: 100%;
				   padding:10px;
				   margin: 0 -10px;
				    // box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.6);
				   h3{
					   margin-bottom:0px;
				   }
			   }
			   .online_payment_info{
				   display: flex;
	   			   // flex-direction: column;
	   			   justify-content: space-between;
	   			   align-items: flex-start;
				   padding: 25px 10px;
				   @include media-breakpoint-down(sm) {
	   				flex-direction: column;
					align-items: center;

					img{
						margin: 10px 0px;
					}
	   			   }
				   @include media-breakpoint-only(md) {
					   flex-direction: column;
	   					align-items: center;

	   					img{
	   						margin: 10px 0px;
	   					}
				   }
				   .addtional_info{
					   padding-top:20px;

				   }
			   }
			   .details{
				   display: flex;
	   				flex-direction: column;
	   				justify-content: center;
	   				align-items: center;
	   				margin: 0 10px;
					padding: 15px 30px;
					// box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.6);
	   				// gap: 30px;
	   				// background: #FFFFFF;

					@include media-breakpoint-down(sm) {
		 			 // padding: 10px;
		 	   		}
				   img{
					   width: 64px;
					   height:auto;
					   margin-right:30px;

				   }
				   b{
					   font-family: 'Verlag Book';
					  // font-style: normal;
					  // font-weight: 500;
					  font-size: 16px;
					  line-height: 24px;
				   }
				   p{
					   font-family: 'Verlag Light';
					  font-style: normal;
					  font-weight: 325;
						font-size: 16px;
						line-height: 145%;
					  // padding:30px;
					  // margin-bottom: 0px;
					  // text-transform:uppercase;
				   }
				   a{
					   display: flex;
					   flex-direction: row;
					   justify-content: center;
					   align-items: center;
					   padding: 8px 60px;
					   gap: 15px;
					   color:white;
					   background: #0E3386;
					   border-radius: 55px;
					   text-decoration:none;
					   margin-bottom: 25px;
					   font-family: 'Verlag Book';
					   font-style: normal;
					   font-weight: 325;
					   font-size: 20px;
					   line-height: 24px;
					   @include media-breakpoint-down(sm) {
	   		 			 font-size: 14px;
						 padding: 8px 20px;
	   		 	   		}
		  				@include media-breakpoint-only(md) {

						}
				   }
			   }
		   }


		}
	}
}
</style>
